import { MODULE_KEYS, FEATURE_KEYS, TELEMETRY_IDS, I18N_KEYS, ROUTE_IDS, ICON_IDS, OPERATION_IDS, } from '../routes/ids.js';
import { ROUTE_INTENT_IDS } from '../route-intent.js';
const AVAILABLE = 'AVAILABLE';
const PLANNED = 'PLANNED';
export const DATA_HUB = {
    id: 'hub.data',
    schemaVersion: 1,
    module: MODULE_KEYS.DATA,
    feature: FEATURE_KEYS.DATA_HUB,
    telemetryId: TELEMETRY_IDS.HUB_DATA,
    accessibilityLabelKey: I18N_KEYS.HUB_DATA_TITLE,
    privacyClassification: 'INTERNAL',
    auditPolicy: 'NONE',
    owner: 'platform',
    hubRouteId: ROUTE_IDS.DATA_HUB,
    titleKey: I18N_KEYS.HUB_DATA_TITLE,
    descriptionKey: I18N_KEYS.HUB_DATA_DESCRIPTION,
    implementationStatus: AVAILABLE,
    operationId: OPERATION_IDS.DATA_HUB,
    groups: [
        {
            id: 'data-reference',
            schemaVersion: 1,
            module: MODULE_KEYS.DATA,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_REFERENCE,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_REFERENCE_TITLE,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: I18N_KEYS.HUB_DATA_REFERENCE_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.instruments',
                    schemaVersion: 1,
                    module: MODULE_KEYS.INSTRUMENTS,
                    feature: FEATURE_KEYS.DATA_INSTRUMENTS,
                    telemetryId: TELEMETRY_IDS.CARD_INSTRUMENTS,
                    accessibilityLabelKey: I18N_KEYS.CARD_INSTRUMENTS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    resourceId: 'instruments',
                    routeId: ROUTE_IDS.DATA_INSTRUMENTS,
                    operationId: OPERATION_IDS.INSTRUMENT_LIST,
                    titleKey: I18N_KEYS.CARD_INSTRUMENTS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_INSTRUMENTS_DESCRIPTION,
                    iconKey: ICON_IDS.DATA,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.INSTRUMENTS },
                    routeIntent: ROUTE_INTENT_IDS.INSTRUMENT_LIST,
                },
            ],
        },
        {
            id: 'data-operational',
            schemaVersion: 1,
            module: MODULE_KEYS.DATA,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_OPERATIONAL,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_OPERATIONAL_TITLE,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: I18N_KEYS.HUB_DATA_OPERATIONAL_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.transactions',
                    schemaVersion: 1,
                    module: MODULE_KEYS.TRANSACTIONS,
                    feature: FEATURE_KEYS.TRANSACTIONS_LIST,
                    telemetryId: TELEMETRY_IDS.CARD_TRANSACTIONS,
                    accessibilityLabelKey: I18N_KEYS.CARD_TRANSACTIONS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    resourceId: 'transactions',
                    routeId: ROUTE_IDS.TRANSACTIONS,
                    operationId: OPERATION_IDS.TRANSACTION_LIST,
                    titleKey: I18N_KEYS.CARD_TRANSACTIONS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_TRANSACTIONS_DESCRIPTION,
                    iconKey: ICON_IDS.TRANSACTIONS,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.TRANSACTIONS },
                    routeIntent: ROUTE_INTENT_IDS.TRANSACTION_LIST,
                },
                {
                    id: 'card.transactionApprovals',
                    schemaVersion: 1,
                    module: MODULE_KEYS.TRANSACTIONS,
                    feature: FEATURE_KEYS.TRANSACTIONS_LIST,
                    telemetryId: TELEMETRY_IDS.CARD_TRANSACTION_APPROVALS,
                    accessibilityLabelKey: I18N_KEYS.CARD_TRANSACTION_APPROVALS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    routeId: ROUTE_IDS.TRANSACTION_APPROVALS,
                    operationId: OPERATION_IDS.TRANSACTION_LIST,
                    titleKey: I18N_KEYS.CARD_TRANSACTION_APPROVALS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_TRANSACTION_APPROVALS_DESCRIPTION,
                    iconKey: ICON_IDS.TRANSACTIONS,
                    implementationStatus: AVAILABLE,
                    wip: true,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.TRANSACTIONS },
                    routeIntent: ROUTE_INTENT_IDS.TRANSACTION_APPROVALS,
                },
                {
                    id: 'card.transactionReversals',
                    schemaVersion: 1,
                    module: MODULE_KEYS.TRANSACTIONS,
                    feature: FEATURE_KEYS.TRANSACTIONS_LIST,
                    telemetryId: TELEMETRY_IDS.CARD_TRANSACTION_REVERSALS,
                    accessibilityLabelKey: I18N_KEYS.CARD_TRANSACTION_REVERSALS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    routeId: ROUTE_IDS.TRANSACTION_REVERSALS,
                    operationId: OPERATION_IDS.TRANSACTION_LIST,
                    titleKey: I18N_KEYS.CARD_TRANSACTION_REVERSALS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_TRANSACTION_REVERSALS_DESCRIPTION,
                    iconKey: ICON_IDS.TRANSACTIONS,
                    implementationStatus: AVAILABLE,
                    wip: true,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.TRANSACTIONS },
                    routeIntent: ROUTE_INTENT_IDS.TRANSACTION_REVERSALS,
                },
                {
                    id: 'card.imports',
                    schemaVersion: 1,
                    module: MODULE_KEYS.IMPORT,
                    feature: FEATURE_KEYS.DATA_IMPORTS,
                    telemetryId: TELEMETRY_IDS.CARD_IMPORTS,
                    accessibilityLabelKey: I18N_KEYS.CARD_IMPORTS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    resourceId: 'import-jobs',
                    routeId: ROUTE_IDS.DATA_IMPORTS,
                    operationId: OPERATION_IDS.IMPORT_LIST,
                    titleKey: I18N_KEYS.CARD_IMPORTS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_IMPORTS_DESCRIPTION,
                    iconKey: ICON_IDS.IMPORT,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.IMPORT },
                    routeIntent: ROUTE_INTENT_IDS.IMPORT_LIST,
                },
                {
                    id: 'card.corporateActions',
                    schemaVersion: 1,
                    module: MODULE_KEYS.CORPORATE_ACTIONS,
                    feature: FEATURE_KEYS.DATA_CORPORATE_ACTIONS,
                    telemetryId: TELEMETRY_IDS.CARD_CORPORATE_ACTIONS,
                    accessibilityLabelKey: I18N_KEYS.CARD_CORPORATE_ACTIONS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    resourceId: 'corporate-actions',
                    routeId: ROUTE_IDS.DATA_CORPORATE_ACTIONS,
                    operationId: OPERATION_IDS.CORPORATE_ACTION_LIST,
                    titleKey: I18N_KEYS.CARD_CORPORATE_ACTIONS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_CORPORATE_ACTIONS_DESCRIPTION,
                    iconKey: ICON_IDS.CORPORATE_ACTIONS,
                    implementationStatus: AVAILABLE,
                    wip: true,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.CORPORATE_ACTIONS },
                    routeIntent: ROUTE_INTENT_IDS.CORPORATE_ACTION_LIST,
                },
            ],
        },
        {
            id: 'data-exceptions',
            schemaVersion: 1,
            module: MODULE_KEYS.DATA,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_EXCEPTIONS,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_EXCEPTIONS_TITLE,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: I18N_KEYS.HUB_DATA_EXCEPTIONS_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.reconciliation',
                    schemaVersion: 1,
                    module: MODULE_KEYS.RECONCILIATION,
                    feature: FEATURE_KEYS.DATA_RECONCILIATION,
                    telemetryId: TELEMETRY_IDS.CARD_RECONCILIATION,
                    accessibilityLabelKey: I18N_KEYS.CARD_RECONCILIATION_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    resourceId: 'reconciliation-runs',
                    routeId: ROUTE_IDS.DATA_RECONCILIATION,
                    operationId: OPERATION_IDS.RECONCILIATION_LIST,
                    titleKey: I18N_KEYS.CARD_RECONCILIATION_TITLE,
                    descriptionKey: I18N_KEYS.CARD_RECONCILIATION_DESCRIPTION,
                    iconKey: ICON_IDS.RECONCILIATION,
                    implementationStatus: AVAILABLE,
                    wip: true,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.RECONCILIATION },
                    routeIntent: ROUTE_INTENT_IDS.RECONCILIATION_LIST,
                },
            ],
        },
        {
            id: 'data-facts',
            schemaVersion: 1,
            module: MODULE_KEYS.DATA,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_FACTS,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_FACTS_TITLE,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: I18N_KEYS.HUB_DATA_FACTS_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.factBatches',
                    schemaVersion: 1,
                    module: MODULE_KEYS.FACTS,
                    feature: FEATURE_KEYS.DATA_FACT_BATCHES,
                    telemetryId: TELEMETRY_IDS.CARD_FACT_BATCHES,
                    accessibilityLabelKey: I18N_KEYS.CARD_FACT_BATCHES_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'investment',
                    resourceId: 'fact-batches',
                    routeId: ROUTE_IDS.DATA_FACT_BATCHES,
                    operationId: OPERATION_IDS.FACT_BATCHES_LIST,
                    titleKey: I18N_KEYS.CARD_FACT_BATCHES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_FACT_BATCHES_DESCRIPTION,
                    iconKey: ICON_IDS.BATCH,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.FACTS },
                    routeIntent: ROUTE_INTENT_IDS.FACT_BATCH_LIST,
                },
            ],
        },
        // ── Market Data ──────────────────────────────────────────────────────────
        // Persona scope: Platform Root only. market.prices.list/get are declared
        // with allowedPersonas: ['PLATFORM_ROOT'] and ownershipPolicy: 'PLATFORM' in
        // packages/contracts/src/operations/market-data.operations.ts, and the
        // MARKET_DATA module key is not a member of the Prisma Module enum, so this
        // group and its cards never resolve for ORG_ADMIN or any other persona.
        // There is no org-scoped market-data read API today; if one is added, this
        // group's condition and the operation's allowedPersonas must be updated
        // together.
        // Org Client: HIDDEN (entire Data Hub is HIDDEN for CLIENT persona).
        {
            id: 'data-market',
            schemaVersion: 1,
            module: MODULE_KEYS.MARKET_DATA,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_MARKET,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_MARKET_TITLE,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: I18N_KEYS.HUB_DATA_MARKET_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.marketPrices',
                    schemaVersion: 1,
                    module: MODULE_KEYS.MARKET_DATA,
                    feature: FEATURE_KEYS.DATA_MARKET_PRICES,
                    telemetryId: TELEMETRY_IDS.CARD_MARKET_PRICES,
                    accessibilityLabelKey: I18N_KEYS.CARD_MARKET_PRICES_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'market-prices',
                    routeId: ROUTE_IDS.DATA_MARKET_PRICES,
                    operationId: OPERATION_IDS.MARKET_PRICES_LIST,
                    titleKey: I18N_KEYS.CARD_MARKET_PRICES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_MARKET_PRICES_DESCRIPTION,
                    iconKey: ICON_IDS.DATA,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.MARKET_DATA },
                },
                {
                    id: 'card.fxRates',
                    schemaVersion: 1,
                    module: MODULE_KEYS.MARKET_DATA,
                    feature: FEATURE_KEYS.DATA_FX_RATES,
                    telemetryId: TELEMETRY_IDS.CARD_FX_RATES,
                    accessibilityLabelKey: I18N_KEYS.CARD_FX_RATES_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'fx-rates',
                    routeId: ROUTE_IDS.DATA_FX_RATES,
                    operationId: OPERATION_IDS.FX_RATES_LIST,
                    titleKey: I18N_KEYS.CARD_FX_RATES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_FX_RATES_DESCRIPTION,
                    iconKey: ICON_IDS.DATA,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.MARKET_DATA },
                    routeIntent: ROUTE_INTENT_IDS.FACT_BATCH_LIST,
                },
                {
                    id: 'card.benchmarks',
                    schemaVersion: 1,
                    module: MODULE_KEYS.MARKET_DATA,
                    feature: FEATURE_KEYS.DATA_BENCHMARKS,
                    telemetryId: TELEMETRY_IDS.CARD_BENCHMARKS,
                    accessibilityLabelKey: I18N_KEYS.CARD_BENCHMARKS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'benchmarks',
                    routeId: ROUTE_IDS.DATA_BENCHMARKS,
                    operationId: OPERATION_IDS.BENCHMARKS_LIST,
                    titleKey: I18N_KEYS.CARD_BENCHMARKS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_BENCHMARKS_DESCRIPTION,
                    iconKey: ICON_IDS.DATA,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.MARKET_DATA },
                    routeIntent: ROUTE_INTENT_IDS.FACT_BATCH_LIST,
                },
                {
                    id: 'card.marketDataProviders',
                    schemaVersion: 1,
                    module: MODULE_KEYS.MARKET_DATA,
                    feature: FEATURE_KEYS.DATA_MARKET_DATA_PROVIDERS,
                    telemetryId: TELEMETRY_IDS.CARD_MARKET_DATA_PROVIDERS,
                    accessibilityLabelKey: I18N_KEYS.CARD_MARKET_DATA_PROVIDERS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'market-data-providers',
                    routeId: ROUTE_IDS.DATA_MARKET_DATA_PROVIDERS,
                    operationId: OPERATION_IDS.MARKET_DATA_PROVIDERS_LIST,
                    titleKey: I18N_KEYS.CARD_MARKET_DATA_PROVIDERS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_MARKET_DATA_PROVIDERS_DESCRIPTION,
                    iconKey: ICON_IDS.DATA,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.MARKET_DATA },
                    routeIntent: ROUTE_INTENT_IDS.FACT_BATCH_LIST,
                },
                {
                    id: 'card.marketDataExceptions',
                    schemaVersion: 1,
                    module: MODULE_KEYS.MARKET_DATA,
                    feature: FEATURE_KEYS.DATA_MARKET_DATA_EXCEPTIONS,
                    telemetryId: TELEMETRY_IDS.CARD_MARKET_DATA_EXCEPTIONS,
                    accessibilityLabelKey: I18N_KEYS.CARD_MARKET_DATA_EXCEPTIONS_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'market-data-exceptions',
                    routeId: ROUTE_IDS.DATA_MARKET_DATA_EXCEPTIONS,
                    operationId: OPERATION_IDS.MARKET_DATA_EXCEPTIONS_LIST,
                    titleKey: I18N_KEYS.CARD_MARKET_DATA_EXCEPTIONS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_MARKET_DATA_EXCEPTIONS_DESCRIPTION,
                    iconKey: ICON_IDS.WARNING,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.MARKET_DATA },
                    routeIntent: ROUTE_INTENT_IDS.FACT_BATCH_LIST,
                },
            ],
        },
        // ── Portfolio and Investment Management ───────────────────────────────────
        // Persona scope: Organization Administrator only. Platform Root receives no
        // organization financial data in a normal session.
        // Org Client: HIDDEN (entire Data Hub is HIDDEN).
        {
            id: 'data-portfolio',
            schemaVersion: 1,
            module: MODULE_KEYS.PORTFOLIO_MGMT,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_PORTFOLIO,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_PORTFOLIO_TITLE,
            privacyClassification: 'FINANCIAL',
            auditPolicy: 'NONE',
            owner: 'investment',
            titleKey: I18N_KEYS.HUB_DATA_PORTFOLIO_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.clientsData',
                    schemaVersion: 1,
                    module: MODULE_KEYS.PORTFOLIO_MGMT,
                    feature: FEATURE_KEYS.DATA_CLIENTS,
                    telemetryId: TELEMETRY_IDS.CARD_CLIENTS_DATA,
                    accessibilityLabelKey: I18N_KEYS.CARD_CLIENTS_DATA_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'clients',
                    routeId: ROUTE_IDS.DATA_CLIENTS,
                    operationId: OPERATION_IDS.DATA_CLIENTS_LIST,
                    titleKey: I18N_KEYS.CARD_CLIENTS_DATA_TITLE,
                    descriptionKey: I18N_KEYS.CARD_CLIENTS_DATA_DESCRIPTION,
                    iconKey: ICON_IDS.USERS,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.PORTFOLIO_MGMT },
                },
                {
                    id: 'card.portfoliosData',
                    schemaVersion: 1,
                    module: MODULE_KEYS.PORTFOLIO_MGMT,
                    feature: FEATURE_KEYS.DATA_PORTFOLIOS,
                    telemetryId: TELEMETRY_IDS.CARD_PORTFOLIOS_DATA,
                    accessibilityLabelKey: I18N_KEYS.CARD_PORTFOLIOS_DATA_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'portfolios',
                    routeId: ROUTE_IDS.DATA_PORTFOLIOS,
                    operationId: OPERATION_IDS.DATA_PORTFOLIOS_LIST,
                    titleKey: I18N_KEYS.CARD_PORTFOLIOS_DATA_TITLE,
                    descriptionKey: I18N_KEYS.CARD_PORTFOLIOS_DATA_DESCRIPTION,
                    iconKey: ICON_IDS.BUSINESS,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.PORTFOLIO_MGMT },
                },
                {
                    id: 'card.mandates',
                    schemaVersion: 1,
                    module: MODULE_KEYS.PORTFOLIO_MGMT,
                    feature: FEATURE_KEYS.DATA_MANDATES,
                    telemetryId: TELEMETRY_IDS.CARD_MANDATES,
                    accessibilityLabelKey: I18N_KEYS.CARD_MANDATES_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'mandates',
                    routeId: ROUTE_IDS.DATA_MANDATES,
                    operationId: OPERATION_IDS.DATA_MANDATES_LIST,
                    titleKey: I18N_KEYS.CARD_MANDATES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_MANDATES_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.PORTFOLIO_MGMT },
                    routeIntent: ROUTE_INTENT_IDS.INSTRUMENT_LIST,
                },
                {
                    id: 'card.positions',
                    schemaVersion: 1,
                    module: MODULE_KEYS.PORTFOLIO_MGMT,
                    feature: FEATURE_KEYS.DATA_POSITIONS,
                    telemetryId: TELEMETRY_IDS.CARD_POSITIONS,
                    accessibilityLabelKey: I18N_KEYS.CARD_POSITIONS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    // Positions is the canonical financial-aggregate resource for
                    // portfolio holdings; the legacy "holdings" resource has been
                    // removed to prevent duplicate financial aggregates.
                    resourceId: 'positions',
                    routeId: ROUTE_IDS.DATA_POSITIONS,
                    operationId: OPERATION_IDS.DATA_POSITIONS_LIST,
                    titleKey: I18N_KEYS.CARD_POSITIONS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_POSITIONS_DESCRIPTION,
                    iconKey: ICON_IDS.HOLDINGS,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.PORTFOLIO_MGMT },
                },
                {
                    id: 'card.cash',
                    schemaVersion: 1,
                    module: MODULE_KEYS.PORTFOLIO_MGMT,
                    feature: FEATURE_KEYS.DATA_CASH,
                    telemetryId: TELEMETRY_IDS.CARD_CASH,
                    accessibilityLabelKey: I18N_KEYS.CARD_CASH_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'cash-positions',
                    routeId: ROUTE_IDS.DATA_CASH,
                    operationId: OPERATION_IDS.DATA_CASH_LIST,
                    titleKey: I18N_KEYS.CARD_CASH_TITLE,
                    descriptionKey: I18N_KEYS.CARD_CASH_DESCRIPTION,
                    iconKey: ICON_IDS.DATA,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.PORTFOLIO_MGMT },
                },
                {
                    id: 'card.performance',
                    schemaVersion: 1,
                    module: MODULE_KEYS.PORTFOLIO_MGMT,
                    feature: FEATURE_KEYS.DATA_PERFORMANCE,
                    telemetryId: TELEMETRY_IDS.CARD_PERFORMANCE,
                    accessibilityLabelKey: I18N_KEYS.CARD_PERFORMANCE_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'performance-series',
                    routeId: ROUTE_IDS.DATA_PERFORMANCE,
                    operationId: OPERATION_IDS.DATA_PERFORMANCE_LIST,
                    titleKey: I18N_KEYS.CARD_PERFORMANCE_TITLE,
                    descriptionKey: I18N_KEYS.CARD_PERFORMANCE_DESCRIPTION,
                    iconKey: ICON_IDS.REPORTS,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.PORTFOLIO_MGMT },
                },
                {
                    id: 'card.positionTransfers',
                    schemaVersion: 1,
                    module: MODULE_KEYS.PORTFOLIO_MGMT,
                    feature: FEATURE_KEYS.DATA_POSITION_TRANSFERS,
                    telemetryId: TELEMETRY_IDS.CARD_POSITION_TRANSFERS,
                    accessibilityLabelKey: I18N_KEYS.CARD_POSITION_TRANSFERS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'position-transfers',
                    routeId: ROUTE_IDS.DATA_POSITION_TRANSFERS,
                    operationId: OPERATION_IDS.POSITION_TRANSFERS_LIST,
                    titleKey: I18N_KEYS.CARD_POSITION_TRANSFERS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_POSITION_TRANSFERS_DESCRIPTION,
                    iconKey: ICON_IDS.HOLDINGS,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.PORTFOLIO_MGMT },
                },
                {
                    id: 'card.performanceFees',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ACCOUNTING,
                    feature: FEATURE_KEYS.DATA_PERFORMANCE_FEES,
                    telemetryId: TELEMETRY_IDS.CARD_PERFORMANCE_FEES,
                    accessibilityLabelKey: I18N_KEYS.CARD_PERFORMANCE_FEES_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'accounting',
                    resourceId: 'performance-fees',
                    routeId: ROUTE_IDS.DATA_PERFORMANCE_FEES,
                    operationId: OPERATION_IDS.ACCOUNTING_PERFORMANCE_FEE_LIST,
                    titleKey: I18N_KEYS.CARD_PERFORMANCE_FEES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_PERFORMANCE_FEES_DESCRIPTION,
                    iconKey: ICON_IDS.REPORTS,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.ACCOUNTING },
                },
            ],
        },
        // ── Settlement and Custody ────────────────────────────────────────────────
        // Module-gated. Org Admin only. Settlement instructions are live; custody remains planned.
        {
            id: 'data-settlement',
            schemaVersion: 1,
            module: MODULE_KEYS.SETTLEMENT,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_SETTLEMENT,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_SETTLEMENT_TITLE,
            privacyClassification: 'FINANCIAL',
            auditPolicy: 'NONE',
            owner: 'investment',
            titleKey: I18N_KEYS.HUB_DATA_SETTLEMENT_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.settlementInstructions',
                    schemaVersion: 1,
                    module: MODULE_KEYS.SETTLEMENT,
                    feature: FEATURE_KEYS.DATA_SETTLEMENT_INSTRUCTIONS,
                    telemetryId: TELEMETRY_IDS.CARD_SETTLEMENT_INSTRUCTIONS,
                    accessibilityLabelKey: I18N_KEYS.CARD_SETTLEMENT_INSTRUCTIONS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'settlement-instructions',
                    routeId: ROUTE_IDS.DATA_SETTLEMENT_INSTRUCTIONS,
                    operationId: OPERATION_IDS.SETTLEMENT_INSTRUCTIONS_LIST,
                    titleKey: I18N_KEYS.CARD_SETTLEMENT_INSTRUCTIONS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_SETTLEMENT_INSTRUCTIONS_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.SETTLEMENT },
                    routeIntent: ROUTE_INTENT_IDS.INSTRUMENT_LIST,
                },
                {
                    id: 'card.custodyBalances',
                    schemaVersion: 1,
                    module: MODULE_KEYS.SETTLEMENT,
                    feature: FEATURE_KEYS.DATA_CUSTODY_BALANCES,
                    telemetryId: TELEMETRY_IDS.CARD_CUSTODY_BALANCES,
                    accessibilityLabelKey: I18N_KEYS.CARD_CUSTODY_BALANCES_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'custody-balances',
                    routeId: ROUTE_IDS.DATA_CUSTODY_BALANCES,
                    operationId: OPERATION_IDS.CUSTODY_BALANCES_LIST,
                    titleKey: I18N_KEYS.CARD_CUSTODY_BALANCES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_CUSTODY_BALANCES_DESCRIPTION,
                    iconKey: ICON_IDS.HOLDINGS,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.SETTLEMENT },
                    routeIntent: ROUTE_INTENT_IDS.INSTRUMENT_LIST,
                },
            ],
        },
        // ── Accounting and Financial Control ─────────────────────────────────────
        // Org Admin can create/update; other org users can list/read.
        {
            id: 'data-accounting',
            schemaVersion: 1,
            module: MODULE_KEYS.ACCOUNTING,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_ACCOUNTING,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_ACCOUNTING_TITLE,
            privacyClassification: 'FINANCIAL',
            auditPolicy: 'NONE',
            owner: 'investment',
            titleKey: I18N_KEYS.HUB_DATA_ACCOUNTING_TITLE,
            implementationStatus: AVAILABLE,
            cards: [
                {
                    id: 'card.fiscalYears',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ACCOUNTING,
                    feature: FEATURE_KEYS.ADMIN_FISCAL_CALENDAR,
                    telemetryId: TELEMETRY_IDS.CARD_FISCAL_YEARS,
                    accessibilityLabelKey: I18N_KEYS.CARD_FISCAL_YEARS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    resourceId: 'fiscal-years',
                    routeId: ROUTE_IDS.ADMIN_FISCAL_YEARS_LIST,
                    operationId: OPERATION_IDS.ACCOUNTING_FISCAL_YEAR_LIST,
                    titleKey: I18N_KEYS.CARD_FISCAL_YEARS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_FISCAL_YEARS_DESCRIPTION,
                    iconKey: ICON_IDS.BATCH,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.ACCOUNTING },
                },
                {
                    id: 'card.journals',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ACCOUNTING,
                    feature: FEATURE_KEYS.DATA_JOURNALS,
                    telemetryId: TELEMETRY_IDS.CARD_JOURNALS,
                    accessibilityLabelKey: I18N_KEYS.CARD_JOURNALS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'journals',
                    routeId: ROUTE_IDS.DATA_JOURNALS,
                    operationId: OPERATION_IDS.JOURNALS_LIST,
                    titleKey: I18N_KEYS.CARD_JOURNALS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_JOURNALS_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.ACCOUNTING },
                },
                {
                    id: 'card.chartOfAccounts',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ACCOUNTING,
                    feature: FEATURE_KEYS.DATA_CHART_OF_ACCOUNTS,
                    telemetryId: TELEMETRY_IDS.CARD_CHART_OF_ACCOUNTS,
                    accessibilityLabelKey: I18N_KEYS.CARD_CHART_OF_ACCOUNTS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'chart-of-accounts',
                    routeId: ROUTE_IDS.DATA_CHART_OF_ACCOUNTS,
                    operationId: OPERATION_IDS.CHART_OF_ACCOUNTS_LIST,
                    titleKey: I18N_KEYS.CARD_CHART_OF_ACCOUNTS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_CHART_OF_ACCOUNTS_DESCRIPTION,
                    iconKey: ICON_IDS.BATCH,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.ACCOUNTING },
                    routeIntent: ROUTE_INTENT_IDS.INSTRUMENT_LIST,
                },
                {
                    id: 'card.fiscalPeriods',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ACCOUNTING,
                    feature: FEATURE_KEYS.DATA_FISCAL_PERIODS,
                    telemetryId: TELEMETRY_IDS.CARD_FISCAL_PERIODS,
                    accessibilityLabelKey: I18N_KEYS.CARD_FISCAL_PERIODS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'fiscal-periods',
                    routeId: ROUTE_IDS.DATA_FISCAL_PERIODS,
                    operationId: OPERATION_IDS.FISCAL_PERIODS_LIST,
                    titleKey: I18N_KEYS.CARD_FISCAL_PERIODS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_FISCAL_PERIODS_DESCRIPTION,
                    iconKey: ICON_IDS.BATCH,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.ACCOUNTING },
                },
            ],
        },
        // ── Compliance and Risk ───────────────────────────────────────────────────
        // Org Admin only. PLANNED. Application authorization is separate from
        // investment compliance evaluation.
        {
            id: 'data-compliance',
            schemaVersion: 1,
            module: MODULE_KEYS.COMPLIANCE,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_COMPLIANCE,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_COMPLIANCE_TITLE,
            privacyClassification: 'FINANCIAL',
            auditPolicy: 'NONE',
            owner: 'investment',
            titleKey: I18N_KEYS.HUB_DATA_COMPLIANCE_TITLE,
            implementationStatus: PLANNED,
            cards: [
                {
                    id: 'card.complianceBreaches',
                    schemaVersion: 1,
                    module: MODULE_KEYS.COMPLIANCE,
                    feature: FEATURE_KEYS.DATA_COMPLIANCE_BREACHES,
                    telemetryId: TELEMETRY_IDS.CARD_COMPLIANCE_BREACHES,
                    accessibilityLabelKey: I18N_KEYS.CARD_COMPLIANCE_BREACHES_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'compliance-breaches',
                    routeId: ROUTE_IDS.DATA_COMPLIANCE_BREACHES,
                    operationId: OPERATION_IDS.COMPLIANCE_BREACHES_LIST,
                    titleKey: I18N_KEYS.CARD_COMPLIANCE_BREACHES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_COMPLIANCE_BREACHES_DESCRIPTION,
                    iconKey: ICON_IDS.WARNING,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.COMPLIANCE },
                },
                {
                    id: 'card.riskExposures',
                    schemaVersion: 1,
                    module: MODULE_KEYS.RISK,
                    feature: FEATURE_KEYS.DATA_RISK_EXPOSURES,
                    telemetryId: TELEMETRY_IDS.CARD_RISK_EXPOSURES,
                    accessibilityLabelKey: I18N_KEYS.CARD_RISK_EXPOSURES_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'risk-exposures',
                    routeId: ROUTE_IDS.DATA_RISK_EXPOSURES,
                    operationId: OPERATION_IDS.RISK_EXPOSURES_LIST,
                    titleKey: I18N_KEYS.CARD_RISK_EXPOSURES_TITLE,
                    descriptionKey: I18N_KEYS.CARD_RISK_EXPOSURES_DESCRIPTION,
                    iconKey: ICON_IDS.WARNING,
                    implementationStatus: AVAILABLE,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.RISK },
                },
            ],
        },
        // ── Tax Management ────────────────────────────────────────────────────────
        // Org Admin only. PLANNED. Rules are effective-dated and source-backed.
        {
            id: 'data-tax',
            schemaVersion: 1,
            module: MODULE_KEYS.TAX,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_TAX,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_TAX_TITLE,
            privacyClassification: 'FINANCIAL',
            auditPolicy: 'NONE',
            owner: 'investment',
            titleKey: I18N_KEYS.HUB_DATA_TAX_TITLE,
            implementationStatus: PLANNED,
            cards: [
                {
                    id: 'card.taxRecords',
                    schemaVersion: 1,
                    module: MODULE_KEYS.TAX,
                    feature: FEATURE_KEYS.DATA_TAX_RECORDS,
                    telemetryId: TELEMETRY_IDS.CARD_TAX_RECORDS,
                    accessibilityLabelKey: I18N_KEYS.CARD_TAX_RECORDS_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'SUCCESS_ONLY',
                    owner: 'investment',
                    resourceId: 'tax-records',
                    routeId: ROUTE_IDS.DATA_TAX_RECORDS,
                    operationId: OPERATION_IDS.TAX_RECORDS_LIST,
                    titleKey: I18N_KEYS.CARD_TAX_RECORDS_TITLE,
                    descriptionKey: I18N_KEYS.CARD_TAX_RECORDS_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.TAX },
                },
            ],
        },
        // ── Document and Evidence Management ─────────────────────────────────────
        // Org Admin only. PLANNED. Secure storage, signed access, retention.
        {
            id: 'data-documents',
            schemaVersion: 1,
            module: MODULE_KEYS.DOCUMENTS,
            feature: FEATURE_KEYS.DATA_HUB,
            telemetryId: TELEMETRY_IDS.HUB_DATA_DOCUMENTS,
            accessibilityLabelKey: I18N_KEYS.HUB_DATA_DOCUMENTS_TITLE,
            privacyClassification: 'FINANCIAL',
            auditPolicy: 'ALWAYS',
            owner: 'investment',
            titleKey: I18N_KEYS.HUB_DATA_DOCUMENTS_TITLE,
            implementationStatus: PLANNED,
            cards: [
                {
                    id: 'card.evidence',
                    schemaVersion: 1,
                    module: MODULE_KEYS.DOCUMENTS,
                    feature: FEATURE_KEYS.DATA_EVIDENCE,
                    telemetryId: TELEMETRY_IDS.CARD_EVIDENCE,
                    accessibilityLabelKey: I18N_KEYS.CARD_EVIDENCE_TITLE,
                    privacyClassification: 'FINANCIAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'investment',
                    resourceId: 'evidence',
                    routeId: ROUTE_IDS.DATA_EVIDENCE,
                    operationId: OPERATION_IDS.EVIDENCE_LIST,
                    titleKey: I18N_KEYS.CARD_EVIDENCE_TITLE,
                    descriptionKey: I18N_KEYS.CARD_EVIDENCE_DESCRIPTION,
                    iconKey: ICON_IDS.IMPORT,
                    implementationStatus: PLANNED,
                    condition: { operator: 'moduleAvailable', module: MODULE_KEYS.DOCUMENTS },
                    routeIntent: ROUTE_INTENT_IDS.INSTRUMENT_LIST,
                },
            ],
        },
    ],
};
